import {
  TI18nInstance,
} from './interface.ts';

export const CLIENT_I18N_INSTANCE: {
  instance: TI18nInstance | undefined,
} = {
  instance: undefined,
};
